import CustomersScreen from "@/UI/screens/CustomersScreen";

export default function CustomersRoute() {
    return <CustomersScreen />;
}
